import moment, { Moment, MomentInput } from 'moment';

export const getJobsiteIncidentAccessEventsInterval = (
  date: MomentInput,
): { startMoment: Moment; endMoment: Moment } => ({
  startMoment: date && moment(date).subtract(2, 'day'),
  endMoment: date && moment(date).add(2, 'day'),
});
